<script lang="ts" setup>
import type { JobItem } from '~/models/Job'

const popularList = ref()

getEmptyPopularList()
async function getEmptyPopularList() {
  const { data, error } = await useSearchApi('/suggest', {
    key: 'get_popular_list',
    method: 'POST',
    initialCache: false,
    body: {
      term: null,
      country: useGetSubdomain(),
    },
  })

  const resp = data.value as { jobs: JobItem[] }
  if (!isEmpty(resp))
    popularList.value = resp.jobs
}
</script>

<template>
  <div>
    <p class="text-xs text-gray-600 mb-4">
      Popular Jobs
    </p>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-4 mb-6 lg:mb-40">
      <a v-for="(item, idx) in popularList" :key="idx" :href="useGenerateSearchUrl(item.title)" class="flex items-center p-2 rounded-sm bg-white text-sm text-[#5843E5] cursor-pointer">
        <span class="line-clamp-1">{{ item.title }}</span>
        <Icon name="material-symbols:arrow-outward" class="w-4 h-4 ml-auto" />
      </a>
    </div>
  </div>
</template>
